import { FC } from 'react';

import { OPopper } from '@src/shared';

import { Typography } from '@mui/material';

import { IoMdImages } from 'react-icons/io';
import { FaTrashAlt } from 'react-icons/fa';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import { IoDocumentTextOutline } from 'react-icons/io5';
import { ImFilePdf } from 'react-icons/im';

import { IMessageFile } from '@src/types';

import { allowedTypesToView, documentTypes, imageTypes, pdfTypes } from '../chatBox.constants';

import './attachFile.scss';
import { BottomSheetDrawer } from '@src/components/BottomSheetDrawer';
import useFileActions from './useFileActions';

interface IAttachFile {
  messageFile?: IMessageFile;
  selectedFile?: File;
  fileType: string;
  onDeleteClick?: () => void;
  onViewFile?: () => void;
  onDownloadFile?: () => void;
  isSent?: boolean;
  hasView?: boolean;
  canDelete?: boolean;
}

const AttachFile: FC<IAttachFile> = ({
  messageFile,
  selectedFile,
  fileType,
  onDeleteClick,
  isSent = false,
  onViewFile,
  onDownloadFile,
  canDelete = true,
}) => {
  const hasView = allowedTypesToView.includes(fileType);
  const { openActionsDrawer, handleDrawerToggle, fileActions, isMobile } = useFileActions({
    isSent,
    onViewFile,
    onDownloadFile,
    onDeleteClick,
    hasView,
    canDelete,
  });

  const fileTitle = messageFile?.fileName || selectedFile?.name || '';

  //Attach file icon
  const getFileIcon = () => {
    if (!fileType) return <IoDocumentTextOutline />;

    if (pdfTypes.includes(fileType)) return <ImFilePdf />;
    if (imageTypes.includes(fileType)) return <IoMdImages />;
    if (documentTypes.includes(fileType)) return <IoDocumentTextOutline />;

    return <IoDocumentTextOutline />;
  };

  let actionComponent;
  if (isSent && !isMobile) {
    actionComponent = (
      <OPopper
        customStyles={{
          root: {
            width: '160px',
          },
        }}
        classes={{
          iconButton: 'options-icon',
        }}
        position="bottom-end"
        icon={<BiDotsVerticalRounded size={24} />}
      >
        {hasView && (
          <div className="menu-item" onClick={onViewFile}>
            View
          </div>
        )}
        <div className="menu-item" onClick={onDownloadFile}>
          Download
        </div>

        {canDelete && (
          <div className="menu-item" onClick={onDeleteClick}>
            Delete
          </div>
        )}
      </OPopper>
    );
  } else if (isSent && isMobile) {
    actionComponent = <BiDotsVerticalRounded size={24} onClick={handleDrawerToggle} />;
  } else {
    actionComponent = <FaTrashAlt onClick={onDeleteClick} style={{ cursor: 'pointer' }} />;
  }

  return (
    <div className={`attached-file-container ${isSent ? 'file-sent' : ''}`}>
      <div className="attached-file">
        {getFileIcon()}
        <Typography className="file-title" title={fileTitle}>
          {fileTitle}
        </Typography>
      </div>
      {actionComponent}

      <BottomSheetDrawer
        title={messageFile?.fileName || selectedFile?.name || ''}
        open={isMobile && openActionsDrawer}
        onClose={handleDrawerToggle}
        actions={fileActions}
      />
    </div>
  );
};

export default AttachFile;
